import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

/**
 * For this MVP there's always one active campaign. This hook fetches it.
 * Later, add campaign selection if there are multiple concurrent campaigns.
 */
export default function useCampaign() {
  const { data } = useQuery({
    queryKey: ['campaigns'],
    queryFn: api.listCampaigns,
  });

  const active = data?.campaigns?.find((c) => c.status === 'active');
  return {
    campaign: active,
    campaignId: active?.id,
  };
}
